import styled from 'styled-components/macro';
import { Image, ImageStyled as ImageStyledComponent } from '@yme/atoms/image';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { Link } from '@yme/components/Link';
import { ProductLabel } from '@yme/molecules/product-label';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const FilterCompareCardStyled = styled(FlexWrapper) `
  position: relative;
`;
export const ImageStyled = styled(Image) `
  ${ImageStyledComponent} {
    width: auto;
    height: 100%;
    object-fit: cover; // TODO: (D.K.) Need clarify
    object-fit: contain;
    aspect-ratio: ${AspectRatio.RectangleLevel3};
  }
`;
export const YAMTIconStyled = styled(SVGIcon) `
  width: 84px;

  svg {
    width: 100%;
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  position: relative;
  aspect-ratio: ${AspectRatio.RectangleLevel3};
  justify-content: center;
`;
export const LinkStyled = styled(Link) `
  position: relative;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
`;
export const TitleStyled = styled(RegularTextLevel2) `
  ${ADAPTIVE.maxWidth.mobile} {
    ${getTextStyles(null, null, 16, 24)}
  }
`;
export const ContainerIconsStyled = styled.span `
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const ProductLabelStyled = styled(ProductLabel) `
  position: absolute;
  top: 16px;
  left: 16px;
`;
